// Colors
export const WHITE = '#ffffff';
export const BLACK = '#1c1c1c';
export const YELLOW = '#e1fd6f';
export const ORANGE = '#ff4d16';
export const PINK = '#ffccd2';
export const GREY = '#bbbbbb';
export const LIGHT_GREY = '#f8f7f7';
